import React, { useEffect, useState } from "react";
import Aside from "./Aside/Aside";
import Map from "./Map/Map";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserPlus, faThumbsUp, faUserCheck, faThumbsDown } from "@fortawesome/free-solid-svg-icons";
import { BsChatLeftTextFill, BsThreeDotsVertical } from "react-icons/bs";
import "../../assets/styles/Profile/Profile.css";
import { useNavigate } from "react-router-dom";
import { MdApartment, MdLocalPhone, MdOutlineLanguage } from "react-icons/md";
import axios from "axios";
import { useSelector } from "react-redux";
import { Server2, Socket } from "../../redux/actions/auth/auth.actions";
import GalleryProfile from "../../components/GalleryProfile";
import { Dropdown } from "react-bootstrap";
import { FaCheck } from "react-icons/fa";
import { AiFillCaretDown } from "react-icons/ai";
import CoverImage from "../My-Profile/CoverImage";
import { Slide, toast, ToastContainer } from "react-toastify";
import { PremiumToast } from "../../components/error/toasts";
import { Subscribe } from "../../components/dialogs/Subscribe";
import { useTranslation } from "react-i18next";
import Linkify from "linkify-react";
import Catalogue from "../../components/product/Catalogue";
import { slugify } from "../../utils";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import ProductReviews from "../../components/product/ReviewsBox";
let screenSize = window.innerWidth;

const UserProfile = ({ Data }) => {
  const { t } = useTranslation();
  const userdata = useSelector((state) => state?.auth?.user?.user);
  const navigate = useNavigate();
  const UserData =  Data;
  const intrest = UserData.profile.interests;
  const langs = UserData.profile.languages;
  const urls = UserData?.business_info?.address?.split(/[\s,]+/).filter(Boolean);
  const [RequestCheck, setRequestCheck] = useState("");
  const [RequestAccept, setRequestAccept] = useState("");
  const [UserFollower, setUserFollower] = useState("");
  const [UserFriend, setUserFriend] = useState("");
  const [blockItems, setBlockItems] = useState([]);
  const [chatBox, setChatBox] = useState(false);
  const [Loading, setLoading] = useState(true);
  const [confirmOpen, setConfirmOpen] = useState({state: false, request: ""});
  const [PopupSubscribe, setPopupSubscribe] = useState(false);
  const [UserFriends, setUserFriends] = useState([]);
  const [UserFollowList, setUserFollowList] = useState([]);
  const [UserFollowers, setUserFollowers] = useState([]);
  const [UserFollowings, setUserFollowings] = useState([]);
  const [FollowingsCount, setFollowingsCount] = useState(0);
  const [followList, setFollowList] = useState("Followings");
  const [GallaryImg, setGallaryImg] = useState([]);
  const [NewData, setNewData] = useState();
  const [UpdateProfile, setUpdateProfile] = useState(false);
  const [ImageProfile, setImageProfile] = useState("");
  const [ImageCover, setImageCover] = useState("");
  const [ProfilePicView, setProfilePicView] = useState(false);
  const [CoverPicView, setCoverPicView] = useState(false);
  const [isOnline, setIsOnline] = useState(UserData?.is_online);

  useEffect(() =>{
    const handler = (data) =>{
      console.log("i, socket, am working, ", data)
      setUpdateProfile(true) 
      if(data.friend === true){
        setUserFriend("Friend")
        setRequestCheck("");
        setRequestAccept("");
      }
      else if(data.friend === false)
        setUserFriend("")
      else if(data.follow === true && data.from === userdata._id)
        setUserFollower("Follower")
      else if(data.follow === false && data.from === userdata._id)
        setUserFollower("")
    }
    // Socket.on("presence", (data) => {
    //   if(data.user_id == UserData._id && data.status === 1){
    //     console.log('online')
    //     setIsOnline(true)
    //   }
    //   else if(data.user_id == UserData._id && data.status === 0){
    //     setIsOnline(false)
    //   }
    // });
    Socket.on("isonline", (data) => {
      setIsOnline(data.status);
    });
    Socket.on("loadProfile",handler)
    return () => {
      // Socket.off("presence")
      Socket.off("loadProfile",handler)
    }
  },[Socket]);

  useEffect(() => {
    GetUserBlock();
    GetUserData();
    var config = {
      method: "get",
      url: Server2 + `/users/ProfileFriends?id=${userdata?._id}&profile=${UserData?._id}`,
    };
    axios(config).then(function (response) {
        setUserFriends([]);
        if (response.data) {
          setUserFriends(response.data);
        }
        response.data.map((e) => {
          if (e?._id === userdata?._id) {
            setUserFriend("Friend");
          } else return "";
        });
        setLoading(false)
      }).catch(function (error) {
        console.log(error);
      });

    config = {
      method: "get",
      url: Server2 + `/users/ProfileFollowers?id=${userdata?._id}&profile=${UserData?._id}`,
    };
    axios(config).then(function (response) {
        setUserFollowers([]);
        if (response.data) {
          setFollowList('Followings')
          setUserFollowList(response.data.Followings);
          setUserFollowers(response.data.Followers);
          setUserFollowings(response.data.Followings);
        }
        setLoading(false)
      }).catch(function (error) {
        console.log(error);
      });

    let data = {
      user: UserData._id,
    };
    var config2 = {
      method: "post",
      url: Server2 + "/users/get-gallery-images",
      headers: { "Content-Type": "application/json" },
      data: data,
    };
    axios(config2)
      .then((response) => {
        setGallaryImg(response.data);
      })
      .catch((err) => {
        console.log(err, "error");
      });
    getOpeningHours()
    setUpdateProfile(false)
  }, [UpdateProfile]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleClick = (e) => {
    navigate(`/profile/${e?._id}/${slugify(e?.fname)}`, {
      state: {
        item: e._id,
      },
    });
  };
  const GetUserData = async () => {
    await fetch(
      Server2 + `/users/userprofile?id=${userdata._id}&user=${UserData._id}`,
      {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      }
    ).then(async (response) => {
      const data = await response.json();
      data?.user?.friend_requests_receive.map((e) => {
        if (e === userdata._id) {
          setRequestCheck("Friend");
        }
        return("");
      });
      data?.user?.friend_requests_sent.map((e) => {
        if (e === userdata._id) {
          setRequestAccept("Accept");
        }
        return("");
      });
      if(data.follow_status === true){
        setUserFollower('Follower')
      }
      setFollowingsCount(data.my_followings_count);
    });
  };

  const handleModelClose = (isChanged) => {
    setCoverPicView(false)
    setProfilePicView(false)
    console.log(isChanged,"picture changed")
    if(isChanged)
      console.log("first")
      // updateNew()
  }

  const FollowPage = () => {
    console.log(FollowingsCount)
    var data = JSON.stringify({
      id: userdata._id,
      user: UserData._id,
    });
    var config = {
      method: "POST",
      url: Server2 + "/users/follow-business",
      data: data,
      headers: { "Content-Type": "application/json" },
    };
    if(userdata?.type && parseInt(userdata?.business_info?.sub_type) < 2 && FollowingsCount > 249) {
      toast(<PremiumToast setPopupSubscribe={setPopupSubscribe} />, {
        style: {
          border: '2px solid rgb(192, 192, 192)',
          padding: '12px',
        }
      });
      return
    } else {
      axios(config)
        .then((response) => {
          setUserFollower("Follower");
            const data = {
            notify: UserData?.notifications?.friend_requests,
            to: UserData?._id,
            from: userdata?._id,
            follow: true
          };
          Socket.emit("follow-request", data);
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  };
  const UnFollowPage = () => {
    var data = JSON.stringify({
      id: userdata._id,
      user: UserData._id,
    });
    var config = {
      method: "POST",
      url: Server2 + "/users/unfollow-business",
      data: data,
      headers: { "Content-Type": "application/json" },
    };
    axios(config)
      .then((response) => {
        setUserFollower("")
        setConfirmOpen({state: false, request: ""});
        var data = {
          from: userdata?._id,
          follow: false
        };
        Socket.emit("unfollow-request", data);
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  const FriendRequest = () => {
    setRequestCheck("");
    var data = JSON.stringify({
      id: userdata._id,
      friend: UserData._id,
    });
    var config = {
      method: "POST",
      url: Server2 + "/users/friend-request",
      data: data,
      headers: { "Content-Type": "application/json" },
    };
    axios(config)
      .then((response) => {
        setRequestCheck("Friend");
        const data = {
          notify: UserData?.notifications?.friend_requests,
          to: UserData?._id,
          from: userdata?._id,
          friend:"Friend"
        };
        Socket.emit("friend-request", data);
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  const AcceptFriendRequest = () => {
    setUserFriend("");
    var data = JSON.stringify({
      id: userdata._id,
      user: UserData._id,
    });
    var config = {
      method: "POST",
      url: Server2 + "/users/accept-friend-request",
      data: data,
      headers: { "Content-Type": "application/json" },
    };
    axios(config)
      .then((response) => {
        setUserFriend("Friend");
        setRequestAccept("");
        const data = {
          to: UserData?._id,
          from: userdata?._id,
          friend: true
        };
        Socket.emit("accept-request", data);
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  const UnFriend = () => {
    setUserFriend("");
    var data = JSON.stringify({
      id: userdata?._id,
      user: UserData?._id,
    });
    var config = {
      method: "POST",
      url: Server2 + "/users/unfriend",
      data: data,
      headers: { "Content-Type": "application/json" },
    };
    axios(config)
      .then((response) => {
        setTimeout(() => {
          setConfirmOpen({state: false, request: ""});
        }, 1000)
        const data = {
          to: UserData?._id,
          from: userdata?._id,
          friend: false
        };
        Socket.emit("unfriend-request", data);
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  const GetUserBlock = () => {
    var config = {
      method: "GET",
      url: Server2 + `/users/getBlockList?id=${userdata?._id}`,
    };
    axios(config)
      .then((response) => {
        setBlockItems(response?.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  
  // both blocks and unblocks a user
  const blockUser = (e) => {

    var config;
    let data = JSON.stringify({
      id: e,
      block_user: UserData?._id,
      unblock_user: UserData?._id,
    });

    if(blockItems.some(user => {return user._id === UserData._id})){
      config = {
        method: "post",
        url: Server2 + "/users/unblock",
        headers: { "Content-Type": "application/json" },
        data: data,
      };
      console.log("yes", blockItems.some(user => {return user._id === UserData._id}))
    } else {
      config = {
        method: "post",
        url: Server2 + "/users/block",
        headers: { "Content-Type": "application/json" },
        data: data,
      };
      blockItems.map(user => {console.log(user._id);return(user)})
      console.log("no", userdata._id)
    }

    axios(config)
      .then(function (response) {
        console.log(response.data, "BlockUser");
        GetUserBlock()
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  const getOpeningHours = () => {
    fetch(
      Server2 + `/users/userprofile?id=${userdata._id}&user=${UserData._id}`,
      {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      }
    ).then(async (response) => {
      const data = await response.json();
      setNewData(data.user)
    });
  }

  const to12Hour = (time24) => {
    const [h, m] = time24.split(":");
    let hour = parseInt(h);
    const ampm = hour >= 12 ? "PM" : "AM";
    hour = hour % 12 || 12;
    return `${hour}:${m} ${ampm}`;
  };

  const formatPhoneNumber = (countryCode, phone) => {
    if (!countryCode || !phone) return '';

    const parsed = parsePhoneNumberFromString(phone, countryCode);

    if (!parsed) return `${phone}`;

    const formatted = parsed.formatInternational();

    const result = formatted.replace(/^(\+\d+\s)(.*)$/, (_, prefix, rest) => {
      return prefix + rest.replace(/\s+/g, '-');
    });

    return result;
  };

  return (
    <>
      <div>
        {(
          UserData?.privacy.block_list.includes(userdata._id) || blockItems?.some(singleUser => {return singleUser._id === UserData._id})
        ) ?
        <>
          <div style={{ height: "80vh" }}>
            <p
              style={{
                display: "flex",
                justifyContent: "center",
                flexDirection: "coloum",
                margin: "auto",
              }}
              className="fs-5 mt-4"
            >
              {t('profileHidden')}
            </p>
          </div>
        </>
        : UserData?.privacy?.profile_info_private === true && UserFriend === "" && UserFollower === "" ? (
          <>
            <div style={{ height: "80vh" }}>
              <p
                style={{
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "coloum",
                  margin: "auto",
                }}
                className="fs-5 mt-4"
              >
                {t('profilePrivate')}
              </p>
            </div>
          </>
        ) : (
          <div className="px-3 bg-white">
            <div>
              {/* Cover Image */}
              <div className="img-cover rounded-3 ">
                <img
                  className="cover"
                  src={UserData?.cover_pic ? UserData?.cover_pic : "/Images/dummy2.png"}
                  alt='user`s coverImage'
                  style={{cursor: 'pointer', maxHeight: screenSize < 768 ? "160px" : "400px"}}
                  onClick={(e) => {
                    setCoverPicView(true)
                    setImageCover(UserData?.cover_pic ? UserData?.cover_pic : "/Images/dummy2.png");
                  }}
                />
              </div>

              {/* Profile Image and Name */}
              <div className="profile row d-flex px-0 justify-content-center align-items-center">
                <div className="col-lg-2 col-md-3 col-12 order-md-1 order-2 text-center text-md-end">
                  <div style={{minWidth: 175}}>
                  <img
                    className="img-admin img-fluid shadow"
                    src={UserData?.profile_pic ? UserData?.profile_pic : "/img/upload-photo.png"}
                    alt='User`s ProfileImage'
                    style={{cursor: 'pointer', minWidth: 160}}
                    onClick={(e) => {
                      setProfilePicView(true)
                      setImageProfile(UserData?.profile_pic ? UserData?.profile_pic : "/img/upload-photo.png");
                    }}
                  />
                  {isOnline === true ?
                    <img
                      src="/Images/contact-online.png"
                      className=""
                      style={{
                          position: "relative",
                          left: "-15px",
                          top: "40px"
                        }}
                      height={14}
                      alt="dot sign"
                    /> :
                    <img
                      src="/Images/contact-idle.png"
                      className=""
                      style={{
                          position: "relative",
                          left: "-15px",
                          top: "40px"
                        }}
                      height={14}
                      alt="dot sign"
                    />
                  }
                  </div>
                </div>
                <div className="col-lg-5 col-md-3 col-sm-12 order-md-2 order-1 pt-3 ">
                  <p
                    className="fw-bold fs-3 text-lg-start text-md-start text-center text-white"
                    style={{ textShadow: "1px 1px #000000" }}
                  >
                    {UserData.fname} {UserData.lname}
                  </p>
                </div>
                <div className="col-lg-5 col-md-6 order-md-2 "></div>
              </div>

              {/* Friend Requests / Follows */}
              <div className="row add-chat">
                {/* Side Panel starts */}
                <div className="offset-md-8 offset-7 col-md-4 col-5 pb-3 pt-4 pt-sm-0">
                  { confirmOpen.state === false ? null :
                    <div className="text-center" style={{ backgroundColor: "#d2f8d2", borderRadius: "8px" }}>
                      <p className="pt-1">{confirmOpen.request === 'unfollow' ? t("confirmUnfollow") : t("confirmUnfriend")}  {UserData?.fname} {UserData?.lname} ?
                      </p>
                      <div className="d-flex justify-content-center flex-column flex-lg-row align-items-center gap-3 pb-2 mb-1">
                        <button className="border-0 rounded-2 py-2 px-md-3 px-2 " onClick={() => setConfirmOpen({state: false, request: ""})}>{t('cancel')}</button>
                        <button className="border-0 rounded-2 p-2 bg-primary text-white" onClick={() => {
                          confirmOpen.request === 'unfollow' ? UnFollowPage() : UnFriend()
                        }}>{t('confirm')}</button>
                      </div>
                    </div>
                  }
                  <div className="d-flex justify-content-end align-items-center gap-2">
                    { UserFriend !== 'Friend' && (
                      UserFollower === "Follower" ? (
                        <Dropdown className="border-0 rounded-2 w-50 fw-bold">
                          <Dropdown.Toggle  className="w-100 border-0 d-flex align-items-center bg-white p-0" id="dropdown-basic" aria-expanded="false">
                              { Loading === true ? 
                                <div className="d-flex justify-content-center" >
                                  <div className="loading3"></div>
                                </div>
                              :
                                <button className="ms-auto border-0 rounded-2 p-1 add-btn" data-bs-toggle="button">
                                  <img src="/Images/unfollow.png" alt="unfollow" style={{height: 30}}/>
                                </button>
                              }
                              <button className="d-none border-0 rounded-2 add-btn w-100 fw-bold px-2 px-lg-3" data-bs-toggle="button" style={{height: '38px'}}>
                                  <div className2025="d-flex align-items-center justify-content-between">
                                    <FaCheck className="btn-icons"/>
                                    <span className="d-none d-lg-inline d-xl-inline postition-relative">
                                      {t('following')}
                                    </span>
                                    <AiFillCaretDown className="d-none d-md-inline" />
                                  </div>
                              </button>
                            {/* <button className="border-0 rounded-2 add-btn w-100 fw-bold px-2 px-lg-3" data-bs-toggle="button" style={{height: '38px'}}>
                              { Loading === true ? 
                                <div className="d-flex justify-content-center" >
                                  <div className="loading3"></div>
                                </div>
                              :
                                <div className="d-flex align-items-center justify-content-between">
                                  <FaCheck className="btn-icons"/>
                                  <span className="d-none d-lg-inline d-xl-inline postition-relative">
                                    Following
                                  </span>
                                  <AiFillCaretDown className="d-none d-md-inline" />
                                </div>
                              }
                            </button> */}
                          </Dropdown.Toggle>
                          <Dropdown.Menu className="w-100 text-center">
                            <Dropdown.Item eventKey="1" onClick={() => setConfirmOpen({state: true, request: "unfollow"})}>
                              <FontAwesomeIcon className="btn-icons me-2 fw-bold" icon={faThumbsDown} /> {t('unfollow')}
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      ) : 
                      // (
                        <>
                          { Loading=== true ?
                            <div className="d-flex justify-content-center">
                              <div className="loading3"></div>
                            </div>
                          :
                            <button type="button" className="border-0 rounded-2 p-1 add-btn" data-bs-toggle="button" onClick={() => FollowPage()} >
                              <img src="/Images/follow.png" alt="follow" style={{height: 30}}/>
                            </button>
                          }
                        <button type="button" className="d-none border-0 rounded-2 add-btn w-50 p-2 fw-bold" data-bs-toggle="button" onClick={() => FollowPage()} >
                            <div className="d-flex align-items-center gap-3 justify-content-center">
                              <div>
                                <FontAwesomeIcon className="btn-icons fw-bold" icon={faThumbsUp} />
                              </div>
                              <span className="d-none d-lg-inline d-xl-inline">
                                {t("follow")}
                              </span>
                            </div>
                        </button>
                        </>
                        // <button type="button" className="border-0 rounded-2 add-btn w-50 p-2 fw-bold" data-bs-toggle="button" onClick={() => FollowPage()} >
                        //   { Loading=== true ?
                        //     <div className="d-flex justify-content-center">
                        //       <div className="loading3"></div>
                        //     </div>
                        //   :
                        //     <div className="d-flex align-items-center gap-3 justify-content-center">
                        //       <div>
                        //         <FontAwesomeIcon className="btn-icons fw-bold" icon={faThumbsUp} />
                        //       </div>
                        //       <span className="d-none d-lg-inline d-xl-inline">
                        //         Follow
                        //       </span>
                        //     </div>
                        //   }
                        // </button>
                      // ) : ""
                    )}
                    { UserData.type === false && userdata.type === false && (
                    RequestCheck === "Friend" ? (
                      <button
                        type="button"
                        className="border-0 rounded-2 add-btn w-50 p-2 fw-bold text-nowrap"
                        data-bs-toggle="button"
                      >
                        <FontAwesomeIcon
                          className="btn-icons me-2 fw-bold"
                          icon={faUserCheck}
                        />
                        <span className="d-none d-lg-inline d-xl-inline">
                          {t('friendRequestSent')}
                        </span>
                      </button>
                    ) : RequestAccept === "Accept" ? (
                      <button
                        type="button"
                        className="border-0 rounded-2 add-btn w-50 p-2 fw-bold text-nowrap"
                        data-bs-toggle="button"
                        onClick={() => AcceptFriendRequest()}
                      >
                        <FontAwesomeIcon className="btn-icons me-2 fw-bold" icon={faUserCheck} />
                        <span className="d-none d-lg-inline d-xl-inline">
                          {t('acceptFriendRequest')}
                        </span>
                      </button>
                    ) : UserFriend === "Friend" ? (
                      <Dropdown className="border-0 rounded-2 add-btn w-50 fw-bold">
                        <Dropdown.Toggle className="w-100 border-0" id="dropdown-basic" aria-expanded="false" style={{backgroundColor: "#6148a1"}}>
                          <button type="button" className="bg-transparent border-0 text-white" data-bs-toggle="button" >
                            { Loading === true ? 
                              <div className="d-flex justify-content-center">
                                <div className="loading3"></div>
                              </div> 
                            :
                              <>
                                <FontAwesomeIcon className="btn-icons me-2 fw-bold" icon={faUserCheck} />
                                <span className="d-none d-lg-inline d-xl-inline postition-relative">
                                  {t('friends')} <AiFillCaretDown style={{ position: "absolute", right: "10%", top: "35%" }} />
                                </span>
                              </>
                            }
                          </button>
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="w-100 text-center">
                          <Dropdown.Item eventKey="1" onClick={() => setConfirmOpen({state: true, request: "unfriend"})} >
                            {t('unfriend')}
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    ) : (
                      <button
                        type="button"
                        className="border-0 rounded-2 add-btn w-50 p-2 fw-bold text-nowrap"
                        data-bs-toggle="button"
                        onClick={() => FriendRequest()}
                      >
                        { Loading === true ?
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              margin: "5%",
                            }}
                          >
                            <div className="loading3"></div>
                          </div> 
                        :
                          <>
                            <FontAwesomeIcon className="btn-icons me-2 fw-bold" icon={faUserPlus} />
                            <span className="d-none d-lg-inline d-xl-none">
                              {t('add')}
                            </span>
                            <span className="d-none d-xl-inline">
                              {t('addAsFriend')}
                            </span>
                          </>
                        }
                      </button>
                    )
                    )}
                    {/* check for the check: new messages from outside friends group */}
                    {UserData?.privacy?.wall_private === false && UserFriend === "" && UserFollower === "" ? ( null ) : (
                      <button
                        type="button"
                        className=" border-0 rounded-2 chat-btn w-50 py-2 px-3 fw-bold"
                        style={{height: 38}}
                        data-bs-toggle="button"
                        onClick={() => setChatBox(true)}
                      >
                        <div className="d-flex justify-content-center gap-2 align-items-center">
                          <BsChatLeftTextFill className="btn-icons fw-bold" />
                          <span className="d-none d-lg-inline d-xl-inline">
                            {UserData?.type === false ? t("chat") : t("inviteToChat")}
                          </span>
                        </div>
                      </button>
                    )}
                    <Dropdown>
                      <Dropdown.Toggle
                        className="border-0 bg-transparent togglebtn d-flex px-0"
                        style={{maxWidth: 35}}
                        variant=""
                        id="dropdown-basic"
                        aria-expanded="false"
                      >
                        <BsThreeDotsVertical className="" size={20} />
                      </Dropdown.Toggle>
                      <Dropdown.Menu className="dropdown-menu">
                        <Dropdown.Item
                          onClick={() => blockUser(userdata?._id)}
                        >
                          {blockItems.some((user) => {return user._id === UserData?._id})? "Ublock":"Block"}
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </div>
              </div>
            </div>

            {/* About and Gallery */}
            <div className="row">
              <div className="col-lg-8 col-md-12 col-sm-12">
                {/* ref={refCheck} > */}
                {UserData?.type === false ? (
                  <>
                    <div
                      className="text-xl-start text-lg-start text-center mx-2 pt-1 pb-2"
                      style={{ height: "200px", overflow: "auto" }}
                    >
                      <p className="fw-bold text-dark">{t('about_me')}</p>
                      <Linkify>
                      <p
                        className=""
                        style={{
                          fontSize: "12px",
                          font: "Roboto",
                          fontWeight: "300",
                        }}
                      >
                        {UserData?.profile.about_me}
                      </p>
                      </Linkify>
                      <p className="fw-bold text-dark">{t('summary')}</p>
                      <div className="">
                        <p
                          className="fw-bold text-dark"
                        >
                          {t('interests')}: &nbsp;
                          {intrest.map((inter, index) => {
                            const last = intrest.slice(-1)[0]
                            return (
                              <span
                                key={index}
                                className=""
                                style={{
                                  fontSize: "12px",
                                  font: "Roboto",
                                  fontWeight: "300",
                                }}
                              >
                                {inter}{inter === last ? null : ","} &nbsp;
                              </span>
                            )
                          })}
                        </p>
                        <p className="fw-bold text-dark">
                          {t('languages')}: &nbsp;
                          {langs.map((item, index) => {
                            const last = langs.slice(-1)[0]
                            return (

                              <span
                                key={index}
                                style={{
                                  fontSize: "12px",
                                  font: "Roboto",
                                  fontWeight: "300",
                                }}
                              >
                                {item}{item === last ? null : ","} &nbsp;
                              </span>
                            )
                          })}
                        </p>
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="mb-2">
                      <p
                        className="fw-bold text-dark ps-2"
                        style={{ fontSize: "16px" }}
                      >
                        {t('businessSummary')}
                      </p>
                      <p
                        className="text-dark ps-2 mt-1"
                        style={{ fontSize: "12px", lineHeight: "18px" }}
                      >
                        {UserData?.business_info.business_summary === null
                          ? " "
                          : <Linkify>{UserData?.business_info.business_summary}</Linkify>
                        }
                      </p>
                    </div>
                    {/* Business Offers */}
                    <div className="border1"></div>
                    <div className="rounded-3 shadow p-3 mb-3">
                      {/* Contacts */}
                      <div className="row text-dark">
                        <div className="pt-2 pe-xxl-4 pe-xl-3 pe-lg-2">
                          <span className="fw-bold fs-6">{t('businessOffer')}</span>
                          <p className="" style={{
                            minHeight: "30px",
                            maxHeight: "fit-content",
                            // overflow: "auto",
                            marginBottom: "5px",
                          }}>
                            {UserData?.business_info?.about_company.map((about, Index) => {
                              const last = UserData?.business_info?.about_company.slice(-1)[0]
                              return (
                                <span
                                  key={Index}
                                  className=""
                                  style={{
                                    fontSize: "12px",
                                    font: "Roboto",
                                    fontWeight: "300",
                                  }}
                                >
                                  {about}{about === last ? null : ","} &nbsp;
                                </span>
                              )
                            })}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="border1"></div>
                    <div className="rounded-3 shadow p-4">
                      {/* Contacts */}
                      <div className="row text-dark mb-2 text-size w-100">
                        <div className="pe-xxl-4 pe-xl-3 pe-lg-2 col-6"  >
                          <span className="fw-bold text-heading-size">{t('openingHours')}</span>
                          <table>
                            <tbody>
                            {NewData?.business_info?.timeZone ?
                            <tr>
                              <td>{t('timeZone')}</td>
                              <td>:&nbsp;</td>
                              <td>{NewData?.business_info?.timeZone ? NewData?.business_info?.timeZone : 'Not Set' }</td>
                            </tr> : ''
                            }
                            {NewData?.business_info?.business_hours?.map((dayInfo, index) => {
                            return (
                              <tr key={index}>
                                <td style={{verticalAlign: 'top'}}>{dayInfo.day}</td>
                                <td style={{verticalAlign: 'top'}}>:&nbsp;</td>
                                <td>
                                  {dayInfo.isOff ? (
                                    "Closed"
                                  ) : (
                                    dayInfo.timeSlots.map((slot, idx) => (
                                      <div key={idx}>
                                        {to12Hour(slot.opening)} - {to12Hour(slot.closing)}
                                        {idx !== dayInfo.timeSlots.length - 1 && <br />}
                                      </div>
                                    ))
                                  )}
                                </td>
                              </tr>
                            );
                          })}
                            </tbody>
                          </table>
                        </div>

                        <div className="ps-xxl-5 ps-xl-4 ps-lg-3 col-6">
                          <span className="fw-bold  pb-2 text-heading-size">
                            {t('aboutBusiness')}
                          </span>
                          <div className="d-flex align-items-center about-b-divs pb-1 text-nowrap">
                            <MdLocalPhone
                              className="me-2 icon-size"
                              style={{minWidth:"20px"}}
                              color="#6599AF"
                            />
                            <span className="fw-bold text-size  ">
                              {t('businessContact')}:
                            </span>
                            {/* <p className="bg-success">&nbsp; +{UserData?.business_info.phone_number}</p> */}
                            <span className="p-text-size">
                              &nbsp;{formatPhoneNumber(UserData.business_info.country_code, UserData.business_info.phone_number)}
                            </span>
                          </div>
                          <div className="d-flex align-items-center about-b-divs pb-1 text-nowrap">
                            <MdApartment
                              className="me-2 icon-size"
                              style={{minWidth:"20px"}}
                              color="#6599AF"
                            />
                            <span className="fw-bold text-size ">
                              {t('businessCategory')}:
                            </span>
                            {/* <p className="F-text-size">&nbsp; {UserData?.business_category}</p> */}
                            <span className="F-text-size">&nbsp;{UserData?.business_category}</span>
                          </div>
                          <div className="d-flex align-items-start about-b-divs pb-1">
                            <MdOutlineLanguage
                              className="me-2 icon-size"
                              style={{minWidth:"20px"}}
                              color="#6599AF"
                            />
                            <div className="d-flex flex-column mt-n1">
                            {urls?.length > 0 ? urls?.map((url, index) => {
                              const href = url.startsWith("http") ? url : `https://${url}`;
                              return (
                                <div className="d-flex">
                                <span className="fw-bold text-size text-nowrap">
                                  {t('websiteUrl')}:
                                </span>
                                <div className="d-flex flex-column about-b-url ms-1">
                                  <a
                                    key={index}
                                    href={href}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-decoration-none adress-size"
                                    title={url}
                                    style={{ color: "#6148a1" }}
                                  >
                                    {url}
                                  </a>
                                </div>
                                </div>
                              );
                            }): 
                            <span className="fw-bold text-size text-nowrap">
                              {t('websiteUrl')}:
                            </span>
                            }
                            </div>
                          </div>
                        </div>
                      </div>
                      <GalleryProfile GallaryImg={GallaryImg} />
                    </div>
                    {/* ^ Gallary */}
                  </>
                )}
                {
                  UserData?.type === false ?
                    <div className="border rounded-3 shadow mt-3">
                      <div className="border1 mt-n1"></div>
                      <div className="py-3 px-2">
                        <GalleryProfile GallaryImg={GallaryImg} />
                      </div>
                    </div>
                    :
                    ""
                }
                { UserData?.type === true ? 
                  <div className="border rounded-3 shadow mt-3 mb-0">
                    <div className="border1 mt-n1"></div>
                    <div className="pt-3 pb-2 px-2">
                      <p className="fw-bold fs-6 px-3">Shop my Store</p>
                      <Catalogue userId={UserData?._id}/>
                    </div>
                  </div> : null
                }
                { UserData?.type === true ? 
                  <div className="border rounded-3 shadow mt-3 mb-0">
                    <div className="border1 mt-n1"></div>
                    <div className="pt-3 pb-2 px-2">
                      <p className="fw-bold fs-6 px-3">Reviews</p>
                      <ProductReviews userId={UserData?._id}/>
                    </div>
                  </div> : null
                }
                {/* Friends */}
                { UserData?.type === false &&
                <div
                  className="friends border rounded-3 shadow"
                  style={{
                    height: "fit-content",
                    marginBottom: "0px",
                    marginTop: UserData?.is_selling === false ? "1rem" : "0rem",
                  }}
                >
                  <div className="border1 mt-n1"></div>
                  {UserData?.privacy?.friend_list_private === false || UserFriend !== "" || UserFollower !== "" ? (
                    <>
                      <div className="d-flex justify-content-between">
                        <p className="friends mt-2 ms-3">
                          {t("usernameConnection", { username: UserData?.fname })} ({UserFriends.length})
                        </p>
                      </div>
                      <div className="friends_row ps-3 my-2" style={{ height: "fit-content", marginBottom: "0px", paddingBottom: "0px" }}>
                        {UserFriends.length === 0 ?
                          <p className=" fs-6 text-capitalize rounded text-center pt-3" style={{ backgroundColor: "#ececec", width: "25%", height: "70px", marginBottom: "20px" }}>
                            {t('noConnectionsFound')}
                          </p> :
                          UserFriends.map((friends, index) => {
                          return (
                            <div
                            className="col-xl-1 col-lg-2 col-md-2 col-sm-2 col-3 px-1 mx-1 d-flex flex-column align-items-center text-center"
                            style={{ cursor: "pointer", position: "relative" }}
                            key={index}
                            onClick={() => handleClick(friends)}
                          >
                            <div style={{ position: "relative", display: "inline-block" }}>
                              <img
                                className="rounded-circle image mb-2"
                                src={
                                  friends.profile_pic
                                    ? friends.profile_pic
                                    : "/img/upload-photo.png"
                                }
                                style={{ width: "40px", height: "40px" }}
                                alt="Admin"
                              />
                              {friends?.is_online === true ? (
                                <img
                                  src="/Images/contact-online.png"
                                  style={{
                                    position: "absolute",
                                    right: "-2px", 
                                    bottom: "6px", 
                                  }}
                                  height={9}
                                  alt="dot sign"
                                />
                              ) : (
                                <img
                                  src="/Images/contact-idle.png"
                                  style={{
                                    position: "absolute",
                                    right: "-2px",
                                    bottom: "6px",
                                  }}
                                  height={9}
                                  alt="dot sign"
                                />
                              )}
                            </div>
                          
                            <p
                              className="jacob"
                              style={{
                                wordWrap: friends?.fname.length > 10 ? "break-word" : "normal",
                              }}
                            >
                              {friends.fname}
                              <br />
                              {friends.lname}
                            </p>
                          </div>
                          
                          );
                        })}
                      </div>
                    </>
                  ) : (
                    <div style={{ textAlign: "center" }} className="py-2 ">
                      <p className="my-5">{t('friendPrivate')}</p>{" "}
                    </div>
                  )}
                </div>}
                {/* Followers */}
                <div
                  className="friends border rounded-3 shadow"
                  style={{
                    height: "fit-content",
                    marginBottom: "0px",
                    marginTop: UserData?.is_selling === false ? "1rem" : "2rem",
                  }}
                >
                  {UserData?.privacy?.friend_list_private === false || UserFriend !== "" || UserFollower !== "" ? (
                    <>
                      <div className="d-flex gap-1" style={{cursor: 'pointer'}}>
                        <div>
                          {followList === "Followings" ? <div className="border1 mt-n1"></div> : <div style={{height: '1px'}}></div>}
                          <p className="friends mt-2 ms-3" onClick={()=> {
                            setFollowList('Followings');
                            setUserFollowList(UserFollowings);
                          }} 
                          >
                            {t("usernameFollowing", {username: UserData?.fname?.trim()})} ({UserFollowings.length})
                          </p>
                        </div>
                        <div>
                          {followList === "Followers" ? <div className="border1 mt-n1"></div> : <div style={{height: '1px'}}></div>}
                          <p className="friends ms-3 mt-2" onClick={()=> {
                              setFollowList('Followers');
                              setUserFollowList(UserFollowers);
                            }}
                          >
                            {t("usernameFollowers", { username: UserData?.fname?.trim()})} ({UserFollowers.length})
                          </p>
                        </div>
                      </div>
                      <div className="friends_row ps-3 mt-3" style={{ height: "fit-content", marginBottom: "0px", paddingBottom: "0px" }}>
                        {UserFollowList.length === 0 ?
                          <p className=" fs-6 text-capitalize rounded text-center pt-3" style={{ backgroundColor: "#ececec", width: "25%", height: "70px", marginBottom: "20px" }}>
                            {t('noConnectionsFound')}
                          </p> :
                          UserFollowList.map((friends, index) => { return (
                          <div
                            className="col-xl-1 col-lg-2 col-md-2 col-sm-2 col-3 px-1 mx-1 d-flex flex-column align-items-center text-center pb-2"
                            style={{ cursor: "pointer", position: "relative" }}
                            key={index}
                            onClick={() => handleClick(friends)}
                          >
                            <div style={{ position: "relative", display: "inline-block" }}>
                              <img
                                className="rounded-circle image mb-2"
                                src={
                                  friends.profile_pic
                                    ? friends.profile_pic
                                    : "/img/upload-photo.png"
                                }
                                style={{ width: "40px", height: "40px" }}
                                alt="Admin"
                              />
                              {friends?.is_online === true ? (
                                <img
                                  src="/Images/contact-online.png"
                                  style={{
                                    position: "absolute",
                                    right: "-2px", 
                                    bottom: "6px", 
                                  }}
                                  height={9}
                                  alt="dot sign"
                                />
                              ) : (
                                <img
                                  src="/Images/contact-idle.png"
                                  style={{
                                    position: "absolute",
                                    right: "-2px",
                                    bottom: "6px",
                                  }}
                                  height={9}
                                  alt="dot sign"
                                />
                              )}
                            </div>
                          
                            <p
                              className="jacob"
                              style={{
                                wordWrap: friends?.fname.length > 10 ? "break-word" : "normal",
                              }}
                            >
                              {friends.fname}
                              <br />
                              {friends.lname}
                            </p>
                          </div>
                          );
                        })}
                      </div>
                    </>
                  ) : (
                    <div style={{ textAlign: "center" }} className="py-2 ">
                      <p className="my-5">{t('followersPrivate')}</p>{" "}
                    </div>
                  )}
                </div>
                {/* Map Start */}
                <div
                  className=""
                  style={{
                    marginTop: "15px",
                  }}
                >
                  <Map UserData={UserData} />
                </div>
                {/* ^ Map End */}
              </div>
              <div className="col-lg-4 col-md-12 col-sm-12">
                <Aside
                  setChatBox={() => setChatBox((e) => !e)}
                  chatBox={chatBox}
                  item={UserData}
                  UserFriend={UserFriend}
                  UserFollower={UserFollower}
                  setIsOnline={setIsOnline}
                  isOnline={isOnline}
                />
                {/* ^ New Post Div */}
              </div>
              {/* ^ Col-4 */}
            </div>
          </div>
        )}
      </div>
      {ProfilePicView === true ? (
        <CoverImage
          style={{zIndex: "2000"}}
          src={ImageProfile}
          handleClose={(isChanged) => handleModelClose(isChanged)}
          type={"profile"}
          user={UserData?._id}
        />
      ) : null}
      {CoverPicView === true ? (
        <CoverImage
          style={{zIndex: "2000"}}
          src={ImageCover}
          handleClose={(isChanged) => handleModelClose(isChanged)}
          type={"Cover"}
          user={UserData?._id}
        />
      ) : null}
      <ToastContainer
        position="bottom-center"
        autoClose={5000}
        limit={1}
        newestOnTop={false}
        hideProgressBar
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        theme="light"
        transition={Slide}
      />
      {PopupSubscribe && <Subscribe setPopupSubscribe={setPopupSubscribe}/>}
    </>
  );
};

export default UserProfile;